import { Flash, Box } from '@acast/decibel';
import T from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const ListItem = styled.li`
  list-style: disc;
  list-style-position: inside;

  & + & {
    margin-top: 4px;
  }
`;

const ValidationErrors = ({ validationErrors }) => {
  if (validationErrors.length === 0) {
    return null;
  }

  return (
    <Box mb={4} flexDirection="column">
      <Flash intent="danger">
        You will not be able to publish the episode until you have corrected the following errors:
        <Box as="ul" flexDirection="column" mt={2}>
          {validationErrors.map((error, index) => (
            <ListItem key={index}>{error}</ListItem>
          ))}
        </Box>
      </Flash>
    </Box>
  );
};

ValidationErrors.propTypes = {
  validationErrors: T.array.isRequired,
};

export default ValidationErrors;
